import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import { DropMenu } from './DropMenu';
import { purpleLogoFull } from '../assets';
import './Navbar.css';

export const Navbar = ({ handleForm, navClick }) => {
  
  // State and Helper function to toggle mobile burger menu
  const [open, setOpen] = useState(false);
  
  const handleClose = () => {
    setOpen(false)
  };

  // Links for DropMenu — internal ones route within the app
  const links = [
    {
      name: "Price Calculator",
      url: "/price-model",
      internal: true,
    } /*,
    {
      name: "Pitch Builder",
      url: "https://pitchbuilder.truerep.io"
    },*/
  ];

  return (
    <div className="nav-container">
      <div className="nav-main">
        
        <div className="nav-links"> 
            <Link to="/">
              <img 
                src={purpleLogoFull} 
                alt="truerep" 
                className="nav-logo" 
              />
            </Link>
            
            <div className="nav-links-box">
              <ScrollLink 
                to="features" 
                className="nav-link" 
                spy={true} 
                smooth={true} 
                offset={-200} 
                duration={500}
                >Features
              </ScrollLink>
              <ScrollLink 
                to="faq" 
                className="nav-link" 
                spy={true} 
                smooth={true} 
                offset={-300} 
                duration={500} 
                >FAQs
              </ScrollLink>
              <DropMenu className="nav-link" links={links} navClick={navClick}>
                Free Tools
              </DropMenu>
            </div>
        </div>
        
        <div className="nav-buttons">
            <button 
              className="btn-alt" 
              onClick={() => navClick("https://app.truerep.io/auth/login")} 
              >Log In
            </button>
            <button 
              className="btn-reg" 
              onClick={handleForm} 
              >Sign Up
            </button>
        </div>

        {/* Mobile Burger Menu elements - only appears when screen width hits 1024px */}

        <div className="nav-burger">
          <svg 
            className={open ? "active" : ""} 
            onClick={() => setOpen(!open)}
            xmlns="http://www.w3.org/2000/svg" 
            width="16"
            height="16"
            fill="currentColor"  
            viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
          </svg>
        </div>
      
      </div>

      {/* When burger menu icon is clicked, it becomes "active" and mobile slide-in menu below will appear */}

      <div className={"nav-mobile " + (open ? "active" : "")}>
        
        <ScrollLink 
          to="features" 
          className="nav-mobile-link" 
          spy={true} 
          smooth={true} 
          offset={-200} 
          duration={500}
          onClick={handleClose} 
          >Features
        </ScrollLink>
        <ScrollLink 
          to="faq" 
          className="nav-mobile-link" 
          spy={true} 
          smooth={true} 
          offset={-300} 
          duration={500}
          onClick={handleClose} 
          >FAQs
        </ScrollLink>
        <Link
          className="nav-mobile-link"
          to="/price-model"
          onClick={handleClose}
          >Free Price Calculator
        </Link>
        {/*<Link 
          className="nav-mobile-link" 
          to="https://pitchbuilder.truerep.io"
          target="_blank"
          onClick={handleClose}
          >Free Pitch Builder
        </Link>*/}
        <Link 
          className="nav-mobile-link" 
          to="https://app.truerep.io/auth/login"
          target="_blank"
          onClick={handleClose}
          >Log In
        </Link>
        <Link 
          className="nav-mobile-link" 
          onClick={() => {
            handleForm();
            handleClose();
          }}
          >Sign Up
        </Link>

      </div>
    </div>
  );
};